/**
 * GECX chat uses body.gecx-chat-open + padding-right to push page content.
 * Theme Swipers ship with resizeObserver: false, so slide widths stick at the
 * squeezed size after chat closes — leaving a white gap beside the hero.
 * Re-measure carousels when the GECX body class or padding transition settles.
 */
(() => {
  const BODY_CLASS = "gecx-chat-open";
  const TRANSITION_MS = 550;

  let scheduled = 0;

  const updateCarousels = () => {
    const carousels = document.querySelectorAll(".swiper-initialized");

    for (const el of carousels) {
      const swiper = el.swiper;

      if (!swiper || typeof swiper.update !== "function") {
        continue;
      }

      swiper.update();
    }

    // HOTFIX: do NOT dispatch a synthetic window "resize" here. It made
    // navigation.js flip body.resize-animation-stopper (animation: none
    // !important for 400ms), hard-resetting CSS animations like the marquee —
    // and because this script's MutationObserver watches body class changes,
    // the stopper's own add/remove re-triggered it in an endless loop
    // (marquee froze/restarted every ~1s). swiper.update() above already
    // re-measures the carousels; the resize event was redundant.
  };

  const scheduleUpdate = () => {
    window.clearTimeout(scheduled);
    scheduled = window.setTimeout(updateCarousels, TRANSITION_MS);
  };

  const onBodyTransitionEnd = event => {
    if (event.target !== document.body) {
      return;
    }

    if (event.propertyName !== "padding-right" && event.propertyName !== "padding-inline-end") {
      return;
    }

    updateCarousels();
  };

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        scheduleUpdate();
        return;
      }
    }
  });

  const start = () => {
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    document.body.addEventListener("transitionend", onBodyTransitionEnd);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();